import type { GlTransactionDialogMode } from "../types/dialog"
import type { GlTransactionDateType } from "../types/searchParams"

import {
  GlTransactionPostedByFilter,
  GlTransactionRowSortField,
  GlTransactionRowType,
  GlTransactionStatus,
} from "@/graphql/codegen/graphql"

export const GL_TRANSACTION_STATUS_LABELS: Record<GlTransactionStatus, string> = {
  [GlTransactionStatus.Posted]: "Posted",
  [GlTransactionStatus.Scheduled]: "Scheduled",
  [GlTransactionStatus.Reversed]: "Reversed",
  [GlTransactionStatus.Cancelled]: "Cancelled",
}

export const GL_TRANSACTION_POSTED_BY_LABELS: Record<GlTransactionPostedByFilter, string> = {
  [GlTransactionPostedByFilter.System]: "System",
  [GlTransactionPostedByFilter.User]: "User",
}

export const GL_TRANSACTION_ROW_TYPE_LABELS: Record<GlTransactionRowType, string> = {
  [GlTransactionRowType.Debit]: "Debit",
  [GlTransactionRowType.Credit]: "Credit",
}

export const GL_TRANSACTION_DATE_TYPE_LABELS: Record<GlTransactionDateType, string> = {
  CREATED_DATE: "Created Date",
  TRANSACTION_DATE: "Transaction Date",
}

export const TRANSACTIONS_SEARCH_PLACEHOLDER = "Search by account number, title, or description"

export const GL_TRANSACTION_DIALOG_CONFIRM_LABELS: Record<GlTransactionDialogMode, string> = {
  edit: "Save",
  view: "Close",
  reverse: "Reverse Transaction",
  cancel: "Cancel Transaction",
}

export enum TransactionsSortableAccessorKey {
  CreatedDate = "createdOn",
  TransactionDate = "transactionDate",
  AccountNumber = "accountNumber",
  AccountTitle = "accountTitle",
  Description = "description",
  Amount = "amount",
  Status = "status",
}

export const sortFieldToAccessorKey = new Map<GlTransactionRowSortField, TransactionsSortableAccessorKey>([
  [GlTransactionRowSortField.CreatedDate, TransactionsSortableAccessorKey.CreatedDate],
  [GlTransactionRowSortField.TransactionDate, TransactionsSortableAccessorKey.TransactionDate],
  [GlTransactionRowSortField.AccountNumber, TransactionsSortableAccessorKey.AccountNumber],
  [GlTransactionRowSortField.AccountTitle, TransactionsSortableAccessorKey.AccountTitle],
  [GlTransactionRowSortField.Description, TransactionsSortableAccessorKey.Description],
  [GlTransactionRowSortField.Amount, TransactionsSortableAccessorKey.Amount],
  [GlTransactionRowSortField.Status, TransactionsSortableAccessorKey.Status],
])

export const accessorKeyToSortField = new Map<TransactionsSortableAccessorKey, GlTransactionRowSortField>([
  [TransactionsSortableAccessorKey.CreatedDate, GlTransactionRowSortField.CreatedDate],
  [TransactionsSortableAccessorKey.TransactionDate, GlTransactionRowSortField.TransactionDate],
  [TransactionsSortableAccessorKey.AccountNumber, GlTransactionRowSortField.AccountNumber],
  [TransactionsSortableAccessorKey.AccountTitle, GlTransactionRowSortField.AccountTitle],
  [TransactionsSortableAccessorKey.Description, GlTransactionRowSortField.Description],
  [TransactionsSortableAccessorKey.Amount, GlTransactionRowSortField.Amount],
  [TransactionsSortableAccessorKey.Status, GlTransactionRowSortField.Status],
])
